import { render, staticRenderFns } from "./businessLetters-table.vue?vue&type=template&id=3972c420&"
import script from "./businessLetters-table.vue?vue&type=script&lang=js&"
export * from "./businessLetters-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports